import { createRouter, createWebHistory } from 'vue-router';

import Index from '@/views/index.vue';

import authRouter from './auth';

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    ...authRouter,
    { path: '/', component: Index, props: true },

    { path: '/transactions', component: () => import('@/views/transactions/index.vue'), props: true },
    { path: '/transactions/:id', component: () => import('@/views/transactions/show.vue'), props: true },

    { path: '/notifications', component: () => import('@/views/notifications/index.vue'), props: true },
    { path: '/notifications/:id/confirm', component: () => import('@/views/notifications/show/processed.vue'), props: true },

    { path: '/accounts', component: () => import('@/views/accounts/index.vue'), props: true },
    { path: '/accounts/create', component: () => import('@/views/accounts/create.vue'), props: true },
    { path: '/accounts/:id', component: () => import('@/views/accounts/show.vue'), props: true },
    { path: '/accounts/:id/edit', component: () => import('@/views/accounts/edit.vue'), props: true },
    {
      path: '/accounts/:id/resync-balance',
      component: () => import('@/views/accounts/resync-balance.vue'),
      props: true,
    },

    { path: '/debts', component: () => import('@/views/debts/index.vue'), props: true },
    { path: '/debts/:id', component: () => import('@/views/debts/show.vue'), props: true },
    { path: '/debts/:id/remainder', component: () => import('@/views/debts/remainder.vue'), props: true },

    { path: '/movements', component: () => import('@/views/movements/index.vue'), props: true },
    { path: '/movements/create', component: () => import('@/views/movements/create.vue'), props: true },
    { path: '/movements/:id', component: () => import('@/views/movements/show.vue'), props: true },

    { path: '/statements', component: () => import('@/views/statements/index.vue'), props: true },
    { path: '/statements/:id', component: () => import('@/views/statements/show.vue'), props: true },

    { path: '/cards/new', component: () => import('@/views/cards/new.vue'), props: true },
    { path: '/cards/:id', component: () => import('@/views/cards/show.vue'), props: true },
    { path: '/cards/:id/edit', component: () => import('@/views/cards/edit.vue'), props: true },

    { path: '/users/me/tokens', component: () => import('@/views/users/me/tokens.vue'), props: true },

    { path: '/past', component: () => import('@/views/past/index.vue'), props: true },
    { path: '/present', component: () => import('@/views/present/index.vue'), props: true },

    { path: '/account', component: () => import('@/views/account/index.vue'), props: true },

    { path: '/tags', component: () => import('@/views/tags/index.vue'), props: true },
    { path: '/tags/create', component: () => import('@/views/tags/create.vue'), props: true },
    { path: '/tags/:id', component: () => import('@/views/tags/show.vue'), props: true },
    {
      path: '/tags/:id/edit',
      component: () => import('@/views/tags/edit.vue'),
      props: true,
    },
  ],
});

export default router;
